import { Button, Checkbox, Input, Modal } from 'antd'
import { AdvertiserSelector } from 'common/components/reloadable/AdvertiserSelector'
import { useState } from 'react'

export interface CreateRetargetingListFormValues {
  name: string
  autoUpdate: boolean
  advertiserId?: number
}

interface CreateRetargetingListButtonProps {
  onSave: (values: CreateRetargetingListFormValues) => Promise<void>
  disabled?: boolean
  showAdvertiserSelector?: boolean
}

const CreateRetargetingListButton = ({
  onSave,
  disabled,
  showAdvertiserSelector,
}: CreateRetargetingListButtonProps) => {
  const [open, setOpen] = useState(false)
  const [name, setName] = useState('')
  const [autoUpdate, setAutoUpdate] = useState(true)
  const [advertiserId, setAdvertiserId] = useState<number | undefined>()
  const [saving, setSaving] = useState(false)

  const resetState = () => {
    setName('')
    setAutoUpdate(true)
    setAdvertiserId(undefined)
  }

  const closeModal = () => {
    setOpen(false)
    resetState()
  }

  const handleSave = async () => {
    if (!name.trim()) {
      return
    }

    setSaving(true)
    try {
      await onSave({
        name: name.trim(),
        autoUpdate,
        advertiserId,
      })
      closeModal()
    } finally {
      setSaving(false)
    }
  }

  return (
    <>
      <Button type="primary" style={{ minWidth: 220 }} onClick={() => setOpen(true)} disabled={disabled}>
        Create Retargeting List
      </Button>

      <Modal
        title="Save as Retargeting List"
        open={open}
        onCancel={closeModal}
        footer={null}
        width={640}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, paddingTop: 8 }}>
          <Input
            placeholder="Enter Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            autoComplete="off"
          />

          {showAdvertiserSelector && (
            <AdvertiserSelector
              placeholder="Select Advertiser"
              value={advertiserId}
              onChange={(value) => setAdvertiserId(value as number | undefined)}
              style={{ width: '100%' }}
            />
          )}

          <Checkbox checked={autoUpdate} onChange={(event) => setAutoUpdate(event.target.checked)}>
            Automatic list updates based on selected filters
          </Checkbox>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, paddingTop: 4 }}>
            <Button onClick={closeModal} style={{ minWidth: 120, height: 36 }}>
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleSave}
              style={{ minWidth: 120, height: 36 }}
              disabled={!name.trim() || (showAdvertiserSelector && !advertiserId)}
              loading={saving}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateRetargetingListButton
